export default {
  mainContainer: {
    padding: ['40px 20px 0 20px', '20px 30px 0 30px', '76px 0 77px 0'],
    margin: '0 auto',
    maxWidth: ['100%', '910px', '940px'],

    openingText: {
      fontSize: ['16px', '16px', '25px'],
      padding: ['0', '0', '0 20px'],
      margin: ['0', '30px 0 0 0', '0'],
      textAlign: ['center', 'left', 'left'],
      fontFamily: 'spoqaBold',
    },
    table: {
      margin: ['20px auto 0 auto', '42px auto 0 auto', '41px auto 0 auto'],
      border: '1px solid black',
      borderCollapse: 'collapse',
      borderSpacing: '0',
      width: '100%',
      maxWidth: ['290px', '645px', '880px'],
      'tr th': {
        backgroundColor: '#D9D9D9',
        fontWeight: 'bold',
        fontSize: ['16px', '16px', '20px'],
        textAlign: 'center',
        verticalAlign: 'bottom',
        p: {
          fontSize: ['11px', '16px', '20px'],
        },
      },
      'td, th': {
        padding: ['', '5px'],
        verticalAlign: 'inherit',
        maxWidth: '50px',
        borderBottom: '1px solid black',
        borderLeft: '1px solid black',
        fontSize: ['', '10px'],
        textAlign: ['left', 'center'],
        p: {
          fontSize: ['10px', '16px', '20px'],
        },
      },
      'tr td': {
        backgroundColor: 'white',
      },
    },
    button: {
      backgroundColor: '#D31445',
      color: 'white',
      borderRadius: '10px',
      width: ['231px', '231px', '307px'],
      margin: ['40px auto 0 auto', '59px auto 0 auto', '71px auto 0 auto'],
      alignSelf: 'center',
      display: 'block',
      cursor: 'pointer',
    },
  },
  modal: {
    padding: ['', '60px'],
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 65%)',
      zIndex: 1011,
    },

    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '300px',
      minHeight: ['', '252px'],
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      border: 'none',
      fontFamily: 'SpoqaHanSansNeo-Regular',
      lineHeight: '24px',
      fontSize: ['', '24px'],
      boxShadow:
        '4px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '8px',
      textAlign: 'center',
    },
    confirmationButton: {
      background: '#E00842',
      border: '1px solid #E00842',
      color: 'white',
      borderRadius: ['8px', '8px', '8px'],
      cursor: 'pointer',
      fontSize: ['16px', '16px'],
      '&: hover': {
        background: '#E00842',
        border: '1px solid #E00842',
      },
    },
  },
}
